export default __webpack_public_path__ + "static/media/vegetables.0332586c.jpg";